import script from "./closeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./closeButton.vue?vue&type=script&setup=true&lang=js"

import "./closeButton.vue?vue&type=style&index=0&id=6a0e69c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0e69c8"]])

export default __exports__